import { render, staticRenderFns } from "./AccountTypeSelectionPage.vue?vue&type=template&id=27e87c50&scoped=true&"
import script from "./AccountTypeSelectionPage.vue?vue&type=script&lang=js&"
export * from "./AccountTypeSelectionPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountTypeSelectionPage.vue?vue&type=style&index=0&id=27e87c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e87c50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VImg})
